import { createAction, handleActions } from 'redux-actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import StatusTextIconBox from '../../component/StatusTextIconBox';
import { CODE_GROUP_ID, PATH_DELIMITER } from '../../constant/Constant';
import CodeUtil from '../../util/CodeUtil';
import NullCheckUtil from '../../util/NullCheckUtil';
import { EventType, ScheduleType, weekdayCdSaveTime2Date } from '../../util/TimeTableUtil';
import { request } from '../ApiModule';

const BASE = 'schedule';
const ACTION_SEARCH = BASE + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_ADD = BASE + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_EDIT = BASE + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_REMOVE = BASE + PATH_DELIMITER + 'ACTION_REMOVE';
const HANDLE_EVENTS = BASE + PATH_DELIMITER + 'HANDLE_EVENTS';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionAdd = createAction(ACTION_ADD);
export const actionEdit = createAction(ACTION_EDIT);
export const actionRemove = createAction(ACTION_REMOVE);

export let convertEvent = (dto) => {
    return {
        ...dto,
        resourceId: dto.uid,
        isAllDay: false,
        title: (
            <div className='event'>
                <div className='event-subject'>{dto.subjectNm}</div>
                <div className='event-content'>
                    {dto.lessonUniversityCd &&
                        CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, dto.lessonUniversityCd)}
                </div>
                {dto.scheduleTypeCd == ScheduleType.CLASS ? (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                        statusCd={dto.enrolmentRegStatusCd}
                    />
                ) : (
                    <></>
                )}
            </div>
        ),
        resource: {},
        start: weekdayCdSaveTime2Date(dto.weekdayCd, dto.bgnTime),
        end: weekdayCdSaveTime2Date(dto.weekdayCd, dto.endTime),
        eventType: EventType.SELECT,
    };
};

export function* scheduleSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_ADD, actionAddSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/user-schedule/semester/${params.semesterId}`,
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: HANDLE_EVENTS,
            payload: result.map((item) => convertEvent(item)),
        });
    }
}

function* actionAddSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'post',
        url: '/api/user-schedule',
        data,
        callback,
    });
}

function* actionEditSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: '/api/user-schedule',
        data,
        callback,
    });
}

function* actionRemoveSaga({ payload: { params, callback } }) {
    yield call(request, {
        method: 'delete',
        url: '/api/user-schedule',
        params,
        callback,
    });
}

const initialState = {
    events: [],
};

const module = handleActions(
    {
        [HANDLE_EVENTS]: (state, { payload: events }) => ({ ...state, events }),
    },
    initialState,
);

export default module;
